import './BookEditButton.css';
import * as React from 'react';
import EditIcon from '@mui/icons-material/Edit';
import {Button, FormControl, InputLabel, LinearProgress, MenuItem, Paper, Select, TextField} from "@mui/material";
import VirtualAutoComplete from "../VirtualAutoComplete/VirtualAutoComplete";
import Divider from "@mui/material/Divider";
import SaveIcon from '@mui/icons-material/Save';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import FullScreenPopup from "../FullScreenPopup/FullScreenPopup";
import TitleWithText from "../TitleWithText/TitleWithText";
import Carousel from "react-material-ui-carousel";
import PreviewEnd from "../../Assets/Images/preview-end.png";
import {deleteData, getJsonData, postJsonData} from "../../Functions/Api";

class BookEditButton extends React.Component {
    state = {
        editing: false,
        languages: [],
        categories: [],
        authors: [],
        data: null
    }

    editedData = {}

    edit() {
        this.setState({editing: true, data: null});

        getJsonData(`/api/books/languages`, (data) => this.setState({languages: data}));
        getJsonData(`/api/books/categories`, (data) => this.setState({categories: data}));
        getJsonData(`/api/books/authors`, (data) => this.setState({authors: data}));
        getJsonData(`/api/books/${this.props.bookId}`, (data) => {
            this.editedData = {
                name: data.name,
                categoryId: data.categoryId,
                languageId: data.languageId,
                authorName: data.authorName,
                downloadCount: data.downloadCount
            };

            this.setState({data: data});
        });
    }

    close() {
        this.setState({editing: false});
    }

    onFieldChange(key, value) {
        this.editedData[key] = value;
    }

    save() {
        if (this.editedData.authorName) {
            let findAuthorName = this.editedData.authorName.trim().toLowerCase();
            this.editedData.authorId = this.state.authors.filter((author) => author.name.trim().toLowerCase() === findAuthorName).map((author) => author.id)[0] || null;
        } else {
            this.editedData.authorId = null;
        }

        if (`${this.editedData.downloadCount}` === `${this.state.data.downloadCount}`) {
            this.editedData.downloadCount = undefined;
        }

        postJsonData(`/api/books/${this.props.bookId}/edit`, this.editedData, () => {
            if (this.props.onDataChanged) {
                this.setState({editing: false})
                this.props.onDataChanged();
            }
        });
    }

    delete() {
        if (window.confirm("Are you sure you want to delete this book from Jafri Library & Google Drive?")) {
            deleteData(`/api/books/${this.props.bookId}`, () => {
                if (this.props.onDataChanged) {
                    this.setState({editing: false})
                    this.props.onDataChanged();
                }
            });
        }
    }

    render() {
        return (
            <div className={this.props.className}>
                <div className="book-edit-button" onClick={this.edit.bind(this)}>
                    <EditIcon/>
                </div>
                {
                    this.state.editing &&
                    <FullScreenPopup open={this.state.editing} onClose={this.close.bind(this)} title={"Edit Book"}>
                        {
                            this.state.data && this.state.authors?.length
                                ?
                                <div className="book-edit-body">
                                    <TitleWithText title="Preview">
                                        <Carousel autoPlay={false} animation={"slide"} navButtonsAlwaysVisible={true} swipe={false}>
                                            {
                                                [...this.state.data.screenshots, PreviewEnd].map((url, i) => {
                                                    return (
                                                        <Paper key={i} className={"book-edit-screenshot-paper"}>
                                                            <div className="book-edit-screenshot-wrapper">
                                                                <div className="book-edit-screenshot" style={{backgroundImage: "url(" + url + ")"}}/>
                                                            </div>
                                                        </Paper>
                                                    );
                                                })
                                            }
                                        </Carousel>
                                    </TitleWithText>
                                    <TitleWithText title="Edit Details" style={{marginTop: "2em"}}>
                                        <div className="book-edit-form">
                                            <TextField type="text" label="Book Name" defaultValue={this.state?.data?.name} onChange={(event) => this.onFieldChange("name", event.target.value)} fullWidth/>
                                        </div>
                                        <div className="book-edit-form">
                                            <FormControl fullWidth>
                                                <VirtualAutoComplete disableListWrap defaultValue={this.state?.data?.authorName || ""} freeSolo
                                                                     options={this.state.authors.map((option) => option.name)}
                                                                     onInputChange={(event, value) => this.onFieldChange("authorName", value)}
                                                                     renderInput={(params) => <TextField {...params} label="Author"/>}/>
                                            </FormControl>
                                        </div>
                                        <div className="book-edit-form">
                                            <FormControl fullWidth>
                                                <InputLabel>Category</InputLabel>
                                                <Select label="Category" fullWidth
                                                        onChange={(event) => this.onFieldChange("categoryId", event.target.value)}
                                                        defaultValue={this.state?.data?.categoryId || ""}>
                                                    <MenuItem value="">
                                                        <em>None</em>
                                                    </MenuItem>
                                                    {this.state.categories?.map((category) => {
                                                        return <MenuItem key={category.id} value={category.id}>{category.name}</MenuItem>
                                                    })}
                                                </Select>
                                            </FormControl>
                                        </div>
                                        <div className="book-edit-form">
                                            <FormControl fullWidth>
                                                <InputLabel>Language</InputLabel>
                                                <Select label="Language" fullWidth
                                                        onChange={(event) => this.onFieldChange("languageId", event.target.value)}
                                                        defaultValue={this.state?.data?.languageId || ""}>
                                                    <MenuItem value="">
                                                        <em>None</em>
                                                    </MenuItem>
                                                    {this.state.languages?.map((language) => {
                                                        return <MenuItem key={language.id} value={language.id}>{language.name}</MenuItem>
                                                    })}
                                                </Select>
                                            </FormControl>
                                        </div>
                                        <div className="book-edit-form">
                                            <TextField type="number" label="Downloads" defaultValue={this.state?.data?.downloadCount || 0} onChange={(event) => this.onFieldChange("downloadCount", event.target.value)} fullWidth/>
                                        </div>
                                        <div style={{display: "flex"}}>
                                            <Button variant="contained" onClick={this.save.bind(this)} startIcon={<SaveIcon/>}>Save</Button>
                                            <Divider sx={{m: 0.5}} orientation="vertical" flexItem/>
                                            <Button variant="contained" onClick={this.delete.bind(this)} startIcon={<DeleteForeverIcon/>}
                                                    color={"error"}>Delete</Button>
                                        </div>
                                    </TitleWithText>
                                </div>
                                :
                                <LinearProgress/>
                        }
                    </FullScreenPopup>
                }
            </div>
        );
    }
}

export default BookEditButton;
